
Turbo.config.forms.submitter = "aria-disabled"

Turbo.config.forms.confirm = (message, element, button) => {
    let content = `
        <dialog id="confirm" class="modal modal-dialog modal-content" style="height: 150px;>
            <article>
                <div class="modal-body">
                    <p>${message}</p>
                </div>
                <div class="modal-footer">
                    <form method="dialog">
                        <button class="btn btn-secondary" value="cancel" class="secondary">Cancel</button>
                        <button class="btn btn-primary" value="confirm">Confirm</button>
                    </form>
                </div>
            </article>
        </dialog>
    `

    document.body.insertAdjacentHTML("beforeend", content)
    let dialog = document.querySelector("#confirm")
    dialog.showModal()

    return new Promise((resolve, reject) => {
        dialog.addEventListener("close", () => {
            resolve(dialog.returnValue == "confirm")
            dialog.remove()
        })
    })
}